<template>
  <div ref="grecaptcha"></div>
</template>
<script>
  export default {
    props: {
      isBindingMfa: {
        type: Boolean,
        required: true
      },
    },
    data() {
      return {
        sitekey: process.env.VUE_APP_GOOGLE_VERIFY_KEY,
        res: ''
      }
    },
    mounted() {
      window.ReCaptchaLoaded = this.loaded;
      var script = document.createElement("script");
      script.src =
        "https://recaptcha.net/recaptcha/api.js?onload=ReCaptchaLoaded&render=explicit&hl=en";
      document.head.appendChild(script);
    },
    methods: {
      loaded() {
        window.grecaptcha.render(this.$refs.grecaptcha, {
          'sitekey': this.sitekey,
          /**
           * res返回的是goole的验证情况，
           * 成功返回字符串
           * 失败不返回字符串
           * 所以根据字符串判断验证情况
           */
          'callback': res => {
            if(res.length > 0) {
              this.res = res
              this.$emit("getValidateCode", res)
            } else {
              this.$emit("getValidateCode", null)
            }
          },
          'expired-callback': () => {
            this.$emit("getValidateCode", this.isBindingMfa ? null : this.res)
          },
        });
      }
    },
  }
</script>
